import React, { useEffect, useState } from "react";
import customerDetailsStyles from "assets/jss/material-kit-pro-react/views/cspDashboard/customerDetailsStyles.js";
import style from "assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.js";
import headersStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/headersStyle.js";
import { makeStyles, Select } from "@material-ui/core";
import get from "lib/requests";
import { ErrorMessage } from "components/Common/toastify";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import classNames from "classnames";
import Loading from "components/Common/loading";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Table from "components/Table/Table.js";
import MenuItem from "@material-ui/core/MenuItem";
import Pagination from "components/Common/pagination.jsx";

const useStyles2 = makeStyles(headersStyle);
const useStyles3 = makeStyles(basicsStyle);
const useStyles = makeStyles(style);
const useStylesCustomerDetailsStyles = makeStyles(customerDetailsStyles);

const perPageOptions = [10, 20, 30, 50, 100];

export default function AllTransactions() {
	const classesCSStyles = useStylesCustomerDetailsStyles();
	const [loading, setLoading] = useState(false);
	const classes = useStyles();
	const [perPage, setPerPage] = useState(10);
	const [tableData, setTableData] = useState([]);
	const [page, setPage] = useState(1);
	const classes3 = useStyles3();
	const [sort, setSort] = useState("DESC");
	const [sortby, setSortBy] = useState("postdate");
	const [showHide, setShowHide] = useState(true);

	const dateSort = () => {
		return (
			<div
				className={classNames(classesCSStyles?.py2, "flex")}
				onClick={() => {
					if (sort === "ASC") {
						setSort("DESC");
						setSortBy("postdate");
					} else {
						setSort("ASC");
						setSortBy("postdate");
					}
				}}>
				<div className={classesCSStyles?.py2} style={{ cursor: "pointer" }}>
					Date
				</div>
				<div className={classNames(classesCSStyles?.sortIcon)}>
					{sortby === "postdate" && sort === "ASC" ? (
						<i className="fas fa-sort-up"></i>
					) : (
						<i className="fas fa-sort-down"></i>
					)}
				</div>
			</div>
		);
	};
	const tableHeaderDefault = ["Document No.", dateSort(), "Type", "Amount"];

	const [tableHeader, setTableHeader] = useState(tableHeaderDefault);

	useEffect(() => {
		getData();
		setTableHeader(tableHeaderDefault);
		return function cleanup() {};
	}, [perPage, page, sortby, sort]);

	const extractData = (data) => {
		if (!data) return [];

		const list = data?.map((item) => {
			return [
				prepareCell(item.documentno),
				prepareCell(item.date),
				prepareCell(item.type),
				prepareCell(item.amount),
			];
		});
		return list;
	};
	const prepareCell = (data) => {
		return <div className={classNames(classesCSStyles?.py2)}>{data}</div>;
	};

	const getData = async () => {
		setLoading(true);
		try {
			await get(
				`/api/transactions?perpage=${perPage}&page=${page}&sort=${sort}&sortby=${sortby}`,
				true
			)
				.then((res) => {
					if (res.data.success) {
						setTableData(res.data.records);
					} else {
						const errorMsg =
							res.data.errors?.map((error) => error).join(", ") || res.data.message;
						console.log(errorMsg, "errorMsg");
						ErrorMessage("All Transactions", errorMsg);
					}
					setLoading(false);
				})
				.catch((error) => {
					let message = "";
					if (error.response?.data.message) {
						message = error.response?.data.message;
					} else {
						message = error?.message;
					}
					ErrorMessage("All Transactions", message);
					setLoading(false);
				});
		} catch (error) {
			ErrorMessage("All Transactions", "Something went wrong try again!!");
			setLoading(false);
		}
	};

	const handlePerPage = (event) => {
		setPerPage(event.target.value);
	};

	return (
		<div className={classNames(classesCSStyles.mx5, classesCSStyles.my30)}>
			<Card className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
				<CardHeader
					color="info"
					className={classNames(classesCSStyles.px5, classesCSStyles.minHeight)}>
					<GridContainer>
						<GridItem xs={12} sm={6} md={6}>
							<h4 className={classesCSStyles?.cartLabel}>All Transactions</h4>
						</GridItem>
						<GridItem xs={12} sm={6} md={6}>
							<div className={classesCSStyles?.editBtns}>
								<div
									onClick={() => {
										setShowHide(!showHide);
									}}
									className={classNames(classesCSStyles.editBtn)}>
									{showHide ? "HIDE" : "SHOW"}
								</div>
							</div>
						</GridItem>
					</GridContainer>
				</CardHeader>
				<CardBody
					className={classNames(
						classesCSStyles.accountSection,
						classesCSStyles.my10
					)}>
					<GridContainer className={classNames(classesCSStyles.marginAuto)}>
						{loading && (
							<Loading
								width={30}
								height={30}
								className={classesCSStyles.absoluteLoading}
							/>
						)}
						{showHide && (
							<GridItem
								xs={12}
								sm={12}
								md={12}
								className={classNames(loading ? classesCSStyles.loading : "")}>
								<Table
									striped
									tableHead={tableHeader}
									tableData={extractData(tableData?.lists)}
									customCellClasses={[
										classNames(
											classes.textLeft,
											classesCSStyles.my5,
											classesCSStyles.py5
										),
										classNames(
											classes.textLeft,
											classesCSStyles.my5,
											classesCSStyles.py5
										),
										classNames(
											classes.textLeft,
											classesCSStyles.my5,
											classesCSStyles.py5
										),
										classNames(
											classes.textLeft,
											classesCSStyles.my5,
											classesCSStyles.py5
										),
									]}
									customClassesForCells={[0, 1, 2, 3, 4, 5, 6, 7, 8]}
									customHeadCellClasses={[
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
										classNames(
											classes.textLeft,
											classesCSStyles?.labelAc,
											classesCSStyles?.tableHeaderCell
										),
									]}
									customHeadClassesForCells={[0, 1, 2, 3]}
								/>

								{!loading &&
									(tableData?.lists?.length === 0 || tableData?.lists?.length === 0) && (
										<div className={classNames(classesCSStyles?.my10)}>
											No data Available. Please try again later.
										</div>
									)}
								<div
									className={classNames(
										classesCSStyles?.moveRight,
										"flex",
										classesCSStyles?.paginationSection,
										classesCSStyles?.justifyInBetween
									)}>
									<Select
										MenuProps={{
											className: classes3.selectMenu,
										}}
										classes={{
											select: classes3.select,
										}}
										value={perPage}
										onChange={handlePerPage}
										inputProps={{}}>
										{perPageOptions.map((item, index) => (
											<MenuItem
												key={index}
												classes={{
													root: classes3.selectMenuItem,
													selected: classes3.selectMenuItemSelected,
												}}
												value={item}>
												{item}
											</MenuItem>
										))}
									</Select>
									{tableData?.totalpages > 0 && (
										<Pagination
											onPageChange={(page) => setPage(page)}
											totalCount={tableData?.itemcount}
											currentPage={page}
											pageSize={perPage}
										/>
									)}
								</div>
							</GridItem>
						)}
					</GridContainer>
				</CardBody>
			</Card>
		</div>
	);
}
